import { FC } from 'react'

import { ProductDetailsContainer } from '../../contexts/ProductDetailsContainer'
import { EmbroiderySection } from '../EmbroiderySection'

import { ColorSection } from './ColorSection'
import { FitsSection } from './FitsSection'
import { SizesSection } from './SizesSection'

/**
 * The attribute selectors that are displayed for the current product.
 */
export const GarmentAttributes: FC = () => {
  const { isProductEmbroiderable, isProductOnWaitlist, colorGroups, portalColorGroups } =
    ProductDetailsContainer.useContainer()

  return (
    <>
      <ColorSection
        colorGroups={colorGroups}
        allowPriceBasedGrouping={portalColorGroups.length === 0}
      />
      <SizesSection />
      <FitsSection />
      <EmbroiderySection
        isPortalColorSelected={false}
        embroiderable={isProductEmbroiderable && !isProductOnWaitlist}
      />
    </>
  )
}
